var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.124,
    height: 36.346,
    viewBox: "0 0 38.124 36.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214957",
    "data-name": "Path 214957",
    d: "M119.6,31.434a1.784,1.784,0,0,0-1.523-2.1l-10.857-1.524-4.953-9.9a1.485,1.485,0,0,0-.762-.762,1.927,1.927,0,0,0-2.666.762l-4.762,9.9L83.215,29.338a1.152,1.152,0,0,0-1.143.571,1.841,1.841,0,0,0,0,2.667l7.81,7.619-1.9,10.857a2.416,2.416,0,0,0,.19,1.143,1.927,1.927,0,0,0,2.667.762l9.714-5.143,9.714,5.143a1.43,1.43,0,0,0,.953.19h.38a1.975,1.975,0,0,0,1.524-2.286l-1.9-10.857,7.809-7.619A1.047,1.047,0,0,0,119.6,31.434Z",
    transform: "translate(-81.501 -16.879)",
    fill: "#735ae5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupStarFilled);
export default __webpack_public_path__ + "static/media/popup_star_filled.3e79ceeb5e24d9763f6925a0ce0da30b.svg";
export { ForwardRef as ReactComponent };